module.exports = __webpack_public_path__ + "media/images/emoticons/cherryblossom-87cb060d27ccef09e474dc624ede0c24.gif";